<style lang="scss">
.wishlist {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(375px, 1fr));
    grid-gap: 30px;
}
.wishlist-item {
    display: grid;
    grid-template-columns: 1fr max-content;
    align-items: start;
    border-radius: $global-radius;

}

.span-2 {
    grid-column: span 2;
}

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.divider {
    display: block;
    margin: 50px 0;
}

</style>

<template>
<div id="secret-santa">
    <h1 class="title">secret santa</h1>

    <div v-if="loaded" v-cloak>
        <template v-if="!namesPicked">
            <h5>names have not been drawn yet!</h5>
            <hr />
        </template>
        <template v-else-if="hideSecretSanta">
            <button @click="toggleSecretSanta" key="show">show secret santa</button>
            <hr />
        </template>
        <template v-else>
            <button @click="toggleSecretSanta" key="hide">hide secret santa</button>
            <hr />
            <h3>you're giving a dope ass gift to</h3>
            <h4>{{ giver_ss.recipient.name }}</h4>
            <div v-if="giver_ss.recipient.wishlist.length">
                <h3>here's some ideas</h3>
                <div class="wishlist">
                    <div v-for="(gift, index) in giver_ss.recipient.wishlist" :key="index" class="wishlist-item card">
                        <div class="span-2"> {{ gift.description }} </div>
                        <a v-if="gift.link" :href="gift.link" target="_blank">view item</a>
                        <div v-else><em>No link</em></div>
                    </div>
                </div>
            </div>
            <div v-else class="button-group">
                <button @click="remind">remind {{ giver_ss.recipient.name }} to update wishlist</button>
                <button disabled v-if="message" style="color: white;">{{ message }}</button>
            </div>
        </template>
        <div class="divider"></div>
        <div class="flex">
            <h3>your wishlist</h3>
            <div class="button-group">
                <button @click="addGift">add</button>
                <button @click="saveWishlist">save</button>
            </div>
        </div>
        <div class="wishlist">
            <div v-for="(gift, index) in wishlist" :key="index" class="wishlist-item card">
                <textarea v-model="gift.description" rows="3" class="span-2" placeholder="Description / Notes"></textarea>
                <input type="text" v-model="gift.link" placeholder="Link" @change="sanitizeLink(gift, $event)" /><br />
                <div class="flex" key="actions">
                    <a :href="gift.link" target="_blank" v-if="gift.link.trim()">view item</a>
                    <span v-else></span>
                    <button @click="removeGift(index)" class="error">remove</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { auth } from '../core/auth.js';
export default {
    name: 'SecretSanta',
    data: function() {
        return {
            giver_ss: {},
            recipient_ss: {},
            clone: null,
            myAuth: auth.session,
            wishlist: [],
            loaded: false,
            hideSecretSanta: true,
            message: '',
        };
    },
    created: async function() {
        let res = await fetch(`/api/graphql`, {
            method: 'POST',
            headers: {},
            credentials: 'same-origin',
            body: JSON.stringify({
                query: `query ($id:ID!) {
                    findUserByID(id:$id) {
                        _id
                        name
                        email
                        role
                        wishlist { description link }
                    }

                    secretSantas {
                        data {
                            year
                            giver {
                                _id
                                name
                                email
                                role
                                wishlist { description link }
                            }
                            recipient {
                                _id
                                name
                                email
                                wishlist { description link }
                            }
                        }
                    }
                }`,
                variables: { id: this.myAuth.user._id }
            }),
        });
        res = await res.json();
        // get secret santa for current year
        let all_ss = _.chain(res)
            .get('secretSantas.data', [])
            .filter(s => s.year === moment().format('YYYY'))
            .value();

        if (all_ss.length) {
            this.giver_ss = all_ss.find(s => s.giver._id === this.myAuth.user._id);
            this.recipient_ss = all_ss.find(s => s.recipient._id === this.myAuth.user._id);
        } else {
            this.giver_ss = { giver: res.findUserByID };
        }

        this.wishlist = this.giver_ss.giver.wishlist;
        if (!this.wishlist.length) this.addGift();
        this.loaded = true;
    },
    computed: {
        namesPicked: function() {
            return _.get(this.recipient_ss, 'giver._id');
        },
    },
    methods: {
        toggleSecretSanta: function() {
            this.hideSecretSanta = !this.hideSecretSanta;
        },
        sanitizeLink: function(gift) {
            gift.link = gift.link.replace(/^https?:\/\//, '');
            if (!gift.link.startsWith('https://') && !gift.link.startsWith('http://'))
                gift.link = `https://${gift.link}`;
        },
        removeGift: function(index) {
            this.wishlist.splice(index, 1);
        },
        addGift: function() {
            this.wishlist.splice(0, 0, { description: '', link: '', });
        },
        saveWishlist: async function() {
            let { _id, name, email, role, } = this.giver_ss.giver;
            let res = await fetch(`/api/graphql`, {
                method: 'POST',
                headers: {},
                credentials: 'same-origin',
                body: JSON.stringify({
                    query: `mutation ($id: ID!, $data: UserInput!) {
                        updateUser(id: $id, data: $data) {
                            _id
                            name
                            email
                            wishlist {
                                description
                                link
                            }
                        }
                    }`,
                    variables: {
                        id: _id,
                        data: {
                            name,
                            email,
                            role,
                            wishlist: this.wishlist.filter(w => w.description.trim() || w.link.trim()),
                        },
                    },
                }),
            });
            res = await res.json();
            this.recipient_ss.recipient = res.updateUser;
            this.wishlist = res.updateUser.wishlist;
            if (!this.wishlist.length) this.addGift();
            else if (this.namesPicked) {
                await fetch(`/api/wishlist`, {
                    method: 'POST',
                    headers: {},
                    body: JSON.stringify({
                        giver: this.recipient_ss.giver,
                        recipient: this.recipient_ss.recipient,
                    }),
                    credentials: 'same-origin',
                });
            }
        },
        remind: async function() {
            let { name } = this.giver_ss.recipient;
            this.message = `Sending reminder to ${name} ...`;
            await fetch(`/api/reminder`, {
                method: 'POST',
                headers: {},
                body: JSON.stringify({
                    giver: this.giver_ss.giver,
                    recipient: this.giver_ss.recipient,
                }),
                credentials: 'same-origin',
            });

            await new Promise(resolve => setTimeout(resolve, 2000));
            this.message = `Email has been sent to ${name}`;

            await new Promise(resolve => setTimeout(resolve, 8000));
            this.message = '';
        },
    },
};
</script>
